export default "__VITE_ASSET__CVb38tm7__"